<script>
    export default {
        methods: {
            alertIE() {
                var ua = window.navigator.userAgent;
                var msie = ua.indexOf('MSIE ');
                var trident = ua.indexOf('Trident/');
                var edge = ua.indexOf('Edge/');
                if (msie > 0) {
                    // IE 10 or older 
                    //Do some stuff
                    alert('重要告示：為確保本系統能正確及有效地為你提供服務，我們建議你使用Google Chrome瀏覽器以得到最佳瀏覽體驗。\n您可以到https://www.google.com/chrome/browser/desktop/index.html查看及下載Chrome瀏覽器。');
                } else if (trident > 0) {
                    // IE 11 
                    //Do some stuff
                    alert('重要告示：為確保本系統能正確及有效地為你提供服務，我們建議你使用Google Chrome瀏覽器以得到最佳瀏覽體驗。\n您可以到https://www.google.com/chrome/browser/desktop/index.html查看及下載Chrome瀏覽器。');
                }
            },
            isIE(){
                var ua = window.navigator.userAgent;
                var msie = ua.indexOf('MSIE ');
                var trident = ua.indexOf('Trident/');
                var edge = ua.indexOf('Edge/');
                var ie = false;
                if (msie > 0) {
                    ie = true;                    
                } 
                else if (trident > 0) {
                    ie = true;
                }
            },
        }
    } 
    </script>



// WEBPACK FOOTER //
// resources/js/shared/detect-ie-mixin.vue